<template>
  <div :class="[{ inline: inline }, 'text-center']">
    <v-progress-circular :size="size" color="primary" indeterminate />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'AppSpinner',

  props: {
    inline: {
      type: Boolean,
      default: () => false,
    },
    size: {
      type: Number,
      default: () => 50,
    },
  },
})
</script>

<style scoped>
.inline {
  display: inline;
}
</style>
